import { RevealWrapper } from '@/hooks/useRevealAnimation'
import { activities } from '@/mocks/home'

export default function ActivitiesSection() {
  return (
    <section id="activities" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        {/* Header */}
        <RevealWrapper>
          <div className="reveal text-center mb-14 md:mb-20">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-secondary-500 inline-block" />
              Activities
            </div>
            <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-primary-700 mb-4">
              다온의 <span className="text-secondary-600">주요 활동</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              마음의 건강을 돌보고 공동체의 성장을 이끄는 다양한 활동을 전개합니다.
            </p>
          </div>
        </RevealWrapper>

        {/* Cards Grid - Asymmetric */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {activities.map((activity, idx) => (
            <RevealWrapper key={activity.id}>
              <div
                className={`reveal reveal-delay-${(idx % 3) + 1} group relative rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300`}
              >
                <div className="relative h-64 md:h-72 overflow-hidden">
                  <img
                    src={activity.image}
                    alt={activity.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-900/40 via-primary-900/10 to-transparent" />
                </div>

                {/* Text overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="text-lg md:text-xl font-semibold text-background-50 mb-2">
                    {activity.title}
                  </h3>
                  <p className="text-sm text-background-200/90 leading-relaxed line-clamp-2">
                    {activity.description}
                  </p>
                </div>
              </div>
            </RevealWrapper>
          ))}
        </div>
      </div>
    </section>
  )
}